<template>
  <SfInput
    v-focus
    class="sf-search-bar"
    type="search"
    :name="name"
    :value="value"
    :placeholder="placeholder"
    :icon="icon"
    v-bind="$attrs"
    v-on="listeners"
    @keyup.enter="$emit('input', value)"
  >
  </SfInput>
</template>
<script>
// import SfInput from "@storefront-ui/vue/src/components/atoms/SfInput/SfInput.vue";
import { focus } from "@storefront-ui/vue/src/utilities/directives";
import SfInput from '~/components/Sf/SfInput.vue';

export default {
  name: "SfSearchBar",
  components: { SfInput },
  directives: {
    focus,
  },
  inheritAttrs: false,
  props: {
    name: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: [Number, String],
      default: null,
    },
    icon: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        "keyup.esc": () => this.$emit("input", ""),
        blur: () => this.$emit("blur"),
        "click:icon": () => this.$emit("click:icon", this.value),
      };
    },
  },
};
</script>
<style lang="scss">
@import "@storefront-ui/shared/styles/components/molecules/SfSearchBar.scss";
</style>
